import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import classes from "./Modal.module.css";
import alerticon from "../Assests/Icons/warning.png";
import CommonButton from "../Components/Buttons/CommonButton";
import { useNavigate } from "react-router-dom";
import {
  UpdatealertType,
  Updaterendernotificationpage,
} from "../Store/Redux/Reducers/Dashboardreducers";

type props = {
  Data?: any;
  onCancel: () => void;
};

function Allertmodal({ Data, onCancel }: props) {
  let dispatch = useDispatch();
  const { AlertData, rendernotificationpage } = useSelector(
    (state: any) => state.Dashboard
  );
  const navigate = useNavigate();

  useEffect(() => {}, [AlertData]);

  const HandleNavigate = (alerttype: number) => {
    navigate("/reports/notificationreport");
    dispatch(UpdatealertType(alerttype));
    dispatch(Updaterendernotificationpage(!rendernotificationpage));
    onCancel();
  };

  return (
    <>
      <div className={classes.parent_container}>
        <div className={classes.child_container}>
          <div className={classes.inline_child}>
            <div className={classes.alert_image_container}>
              <img
                style={{ height: 80 }}
                // className={classes.blinkAnime}
                src={alerticon}
                alt="alerticon"
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className={classes.alert_container}>
          {AlertData?.pf_alert ||
          AlertData?.hv_alert ||
          AlertData?.lv_alert ||
          AlertData?.power_fail ||
          AlertData?.communication_fail ||
          AlertData?.eb_power === 0 ? (
            <div>
              {AlertData?.eb_power === 0 ? <p>Power Off Alert</p> : null}
              {AlertData?.pf_alert ? (
                <p
                  onClick={() => {
                    // navigate("/reports/notificationreport", {
                    //   state: { alert: 3 },
                    // });
                    // dispatch(UpdatealertType(!alertType));
                    // onCancel();
                    HandleNavigate(3);
                  }}
                >
                  Poor Power Alert
                </p>
              ) : null}
              {AlertData?.hv_alert ? (
                <p
                  onClick={() => {
                    // dispatch(UpdatealertType(!alertType));
                    // navigate("/reports/notificationreport", {
                    //   state: { alert: 1 },
                    // });
                    HandleNavigate(1);
                  }}
                >
                  High Voltage Alert
                </p>
              ) : null}
              {AlertData?.lv_alert ? (
                <p
                  onClick={() => {
                    // dispatch(UpdatealertType(!alertType));
                    // navigate("/reports/notificationreport", {
                    //   state: { alert: 2 },
                    // });
                    HandleNavigate(2);
                  }}
                >
                  Low Voltage Alert
                </p>
              ) : null}
              {/* <p
                onClick={() => {
                  HandleNavigate(2);
                }}
              >
                Low Voltage Alert
              </p> */}
              {AlertData?.power_fail ? (
                <p
                  onClick={() => {
                    // dispatch(UpdatealertType(!alertType));
                    // navigate("/reports/notificationreport", {
                    //   state: { alert: 4 },
                    // });
                    HandleNavigate(4);
                  }}
                >
                  Power Fail Alert
                </p>
              ) : null}
              {AlertData?.communication_fail ? (
                <p
                  onClick={() => {
                    // dispatch(UpdatealertType(!alertType));
                    // navigate("/reports/notificationreport", {
                    //   state: { alert: 5 },
                    // });
                    HandleNavigate(5);
                  }}
                >
                  Communication Fail Alert
                </p>
              ) : null}
            </div>
          ) : (
            <p>No Alerts to show</p>
          )}
          <div style={{ alignSelf: "end" }}>
            <CommonButton
              name="Close"
              onClick={onCancel}
              type="button"
              style={{ padding: "6px 12px" }}
              classname="submit_btn"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Allertmodal;
